function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SaintKittsAndNevisFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_3023",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      rx: "-1",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_3023)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21L24 3H0Z",
      fill: "#5EAA22"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.709654 23.7555L1.07134 24.159L1.52202 23.8581L28.7177 5.70553L29.3173 5.30531L28.8361 4.76852L24.8455 0.316783L24.4839 -0.0866961L24.0332 0.214127L-3.16253 18.3667L-3.76213 18.767L-3.28094 19.3038L0.709654 23.7555Z",
      fill: "#272727",
      stroke: "#FFD018",
      strokeWidth: "1.25"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.0665 15.6887L8.25004 17.1097L7.72863 15.509L6.10706 14.9935L7.4583 14.1681L7.29549 12.4937L8.62911 13.5191L10.0104 12.7534L9.62303 14.4589L10.7313 15.7344L9.0665 15.6887Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.5665 10.7739L15.75 12.1949L15.2286 10.5941L13.6071 10.0787L14.9583 9.25321L14.7955 7.57889L16.1291 8.60422L17.5104 7.83854L17.123 9.54405L18.2313 10.8195L16.5665 10.7739Z",
      fill: "#F7FCFF"
    })]
  })]
}));
//# sourceMappingURL=SaintKittsAndNevis.js.map